<template>
  <div class="chart-pie1">
    <div v-if="clickTitle" class="m-title" style="cursor: pointer;" @click.stop="$emit('click-title', conf.goID)">
      {{ conf.title || '无' }}
    </div>
    <div v-else class="m-title">{{ conf.title || '无' }}</div>
    <div class="board-box" v-loading="loading">
      <select-range v-if="source === 'serviceXc_1'" :ser-data="filterList" @range-change="rangeChange" />
      <select-range v-else :eng-data="filterList" @range-change="rangeChange" />
      <div :id="chartId" class="chart1"></div>
    </div>
  </div>
</template>

<script>
import common from './mixins/common'

/**
 * 柱形图
 */
export default {
  mixins: [common],
  name: 'ChartPie1',
  props: {
    /**
     * 放置源头
     * - serviceXc 管理-现场服务单数量
     * - serviceXc_1 上 - 服务商角度
     * - serviceYw 管理-现场服务单数量-运维
     */
    source: {
      type: String,
      default: 'serviceXc'
    },
    clickTitle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      /** 是否需要更新下拉列表数据 */
      isUpdateFilter: true,
      filterList: [],
      chartData: {}
    }
  },
  computed: {
    conf: function() {
      const Map = {
        serviceXc: {
          title: '现场服务单数量工程师/服务商 - 工程师',
          goID: 'serviceXc_1',
          fieldConf: { xField: 'ENGINEER_NAME', filterField: 'ENGINEER_NAME', top10: true }
          // fieldConf: { mock: true, xField: 'name', top10: true }
        },
        serviceXc_1: {
          title: '现场服务单数量工程师/服务商 - 服务商',
          goID: 'serviceXc',
          fieldConf: { xField: 'SERVICE_NAME', filterField: 'SERVICE_NAME', top10: true }
        },
        serviceYw: {
          title: '运维现场服务单故障类型统计',
          fieldConf: { xField: 'WORK_ORDER_TYPE_DESC', filterField: 'ENGINEER_NAME' },
          triggerClick: true
          // fieldConf: { mock: true, xField: 'stage' }
        }
      }

      return Map[this.source] || {}
    }
  },
  watch: {
    chartData: function() {
      this.updateChart()
    }
  },
  mounted: function() {
    this.getData()
  },
  methods: {
    updateChart: function() {
      let chartData = this.chartData,
        echarts = this.getEChartConstructor()
      let options = {
        title: {
          text: ['{name|总数 } \n', `{value|${chartData.total}}{unit|个 }`].join(''),
          top: 'center',
          left: '45%',
          textAlign: 'center',
          textStyle: {
            rich: {
              name: { color: '#4B535E', fontSize: 14 },
              value: {
                color: '#2C3542',
                fontSize: '21',
                fontWeight: 'bold',
                lineHeight: '28'
              },
              unit: { color: '#4B535E', fontSize: 12 }
            }
          }
        },
        legend: {
          show: true,
          type: 'scroll',
          orient: 'vertical',
          right: -50,
          top: 20,
          bottom: 20,
          formatter: function(name) {
            return `{a|${echarts.format.truncateText(name, 80, '14px Microsoft Yahei', '…')}}`
          },
          textStyle: { rich: { a: { width: 80, align: 'left' } } },
          tooltip: {
            show: true
          },
          data: chartData.legend
        },
        series: [
          {
            name: '',
            type: 'pie',
            center: ['45%', 'center'],
            radius: ['50%', '80%'],
            avoidLabelOverlap: true,
            label: { show: true, position: 'inner', formatter: '{d}%' },
            labelLine: {
              show: false
            },
            data: chartData.series
          }
        ],
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        }
      }

      this.chartIns && this.chartIns.setOption(options)
    },

    /**
     * 处理数据
     * @param {[]} list
     */
    processList: function(list) {
      let { xField, filterField, top10 } = this.conf.fieldConf

      let filterMap = {}
      let filterList = []

      let legend = [],
        series = [],
        total = 0

      let categoryMap = {}

      // 取前 10 名数据
      if (top10) {
        let top = 10
        list.map(v => {
          let cur = v[xField],
            f = v[filterField]

          if (!filterMap[f]) {
            filterMap[f] = true
            filterList.push({ label: f, value: f })
          }

          if (!categoryMap[cur]) categoryMap[cur] = { name: cur, value: 0 }
          categoryMap[cur].value += 1
        })
        let newList = Object.keys(categoryMap)
          .map(cur => {
            return categoryMap[cur]
          })
          .sort((a, b) => a.value - b.value)

        let topArr = newList.slice(0, top)
        total += topArr.reduce((total, current) => {
          legend.push(current.name)

          return (total += current.value)
        }, 0)

        let otherArr = {
          name: '其他',
          value: newList.slice(top).reduce((total, current) => (total += current.value), 0)
        }
        total += otherArr.value

        series = topArr
        if (otherArr.value) {
          legend.push('其他')
          series.push(otherArr)
        }
      } else {
        list.map(v => {
          let curX = v[xField],
            f = v[filterField]

          if (!filterMap[f]) {
            filterMap[f] = true
            filterList.push({ label: f, value: f })
          }

          if (!categoryMap[curX]) categoryMap[curX] = []
          categoryMap[curX].push(v)
        })

        legend = Object.keys(categoryMap)
        series = legend.map(curX => {
          let n = (categoryMap[curX] || []).reduce((total, cur) => (total += 1), 0)

          total += n
          return {
            name: [curX].join(','),
            value: n
          }
        })
      }

      this.chartData = { legend, series, total }

      if (this.isUpdateFilter) {
        this.filterList = filterList
        this.isUpdateFilter = false
      }
    },

    /**
     * 获取数据
     * @param {import('./SelectRange.vue').IRange} range 选择日期、品牌、工程师
     */
    getData: function(range) {
      let condition = this.condition,
        /** @type {import('../index.vue').IRoleId} */
        roleId = this.roleId,
        { mock, filterField, timeField = 'YW_SERVICE_ORDER_CREATE_TIME' } = this.conf.fieldConf,
        source = this.source

      if (range) {
        if (range.type === 'date') {
          const tf = 'YYYY-MM-DD'
          // 日期变化
          let [start = '', end = ''] = range.data.current
          if (start === end) {
            // LIKE
            condition[`${timeField}:2`] = start + '%'
          } else {
            // <= 接口不包含此临界值，故需 +1 或者拼接时分秒
            end = moment(end)
              .add(1, 'day')
              .format(tf)

            condition[`${timeField}:5`] = start
            condition[`${timeField}:6`] = end
          }
          if (!start && !end) {
            delete condition[`${timeField}:2`]
            delete condition[`${timeField}:5`]
            delete condition[`${timeField}:6`]
          }
        } else if (range.type === 'engger' || range.type === 'service') {
          let /** filter value */ fv = range.data.current,
            sourceList = this.sourceList

          let list = fv ? sourceList.filter(v => v[filterField] === fv) : sourceList
          this.isUpdateFilter = false

          this.processList(list)
          return
        }
      }

      this.loading = true
      let requestFn = ''
      if (source === 'serviceXc' || source === 'serviceXc_1') {
        requestFn = this.api.queryList('YW_SERVICE_ORDER_V1', { p2: condition, p9: '' }, `${roleId}_chart_4_${source}`)
      } else if (source === 'serviceYw') {
        condition['WORK_ORDER_CATEGORY:0'] = '1'
        requestFn = this.api.queryList('YW_SERVICE_ORDER_V1', { p2: condition, p9: '' }, `${roleId}_chart_5_serviceYw`)
      }
      requestFn &&
        requestFn.then(
          res => {
            this.loading = false
            let resData = (this.sourceList = res.result)

            // TODO: 模拟数据
            if (mock) {
              resData = this.genTableData(100)
            }

            this.isUpdateFilter = true
            this.processList(resData)
          },
          err => {
            this.loading = false
          }
        )
    }
  }
}
</script>

<style lang="postcss">
.chart-pie1 {
  & .board-box {
    padding: 10px;
    height: auto;

    & .chart1 {
      height: 260px;
    }
  }
  & .select-range {
    position: static;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/viewBoard/components/ChartPie1.vue